"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_types_1 = require("@caddigital/sok-types");
var sok_ui_1 = require("@caddigital/sok-ui");
var ListColumnsToggle = function (props) {
    if (props.renderIf())
        return (React.createElement(React.Fragment, null,
            React.createElement(sok_ui_1.Dropdown2, { className: "filter-list-dropdown" },
                React.createElement(sok_ui_1.Button, { onClick: props.toggleColumnsDropdown, className: 'full-width text-left', text: (0, translation_1.getLocalization)('userfront/project/files/buttons/columns'), color: "dark-gray", border: 'yellow', icon: React.createElement(sok_ui_1.Icon, { key: "icon", className: "fal fa-columns" }), iconRight: React.createElement(sok_ui_1.Icon, { key: "right-icon", className: "fa-chevron-down" }) }),
                React.createElement(sok_ui_1.Dropdown2Menu, null,
                    React.createElement(sok_ui_1.ClickWall, null,
                        React.createElement(sok_ui_1.Dropdown2MenuItem, { onClick: function () {
                                if (props.currentProject) {
                                    props.toggleAllMetadataColumns(props.metadata, props.filteredMetadata.length === 0 ? true : false, props.currentProject.id);
                                }
                            } },
                            React.createElement("span", null,
                                React.createElement(sok_ui_1.Icon, { className: props.filteredMetadata.length === 0
                                        ? 'fa-check-square'
                                        : 'fa-square', prefix: "far" }),
                                "\u00A0",
                                ' ',
                                (0, translation_1.getLocalization)('userfront/project/files/buttons/columns/filter/selectAll'))),
                        props.metadata &&
                            props.metadata.reduce(function (acc, pm) {
                                if ((pm.bitField & sok_types_1.CustomMeta.FILES_LIST) === 0 ||
                                    (pm.bitField & sok_types_1.CustomMeta.HIDE_ON_FILES_LIST) > 0) {
                                    return acc;
                                }
                                var value = props.filteredMetadata.find(function (i) { return i.identifier === pm.identifier; })
                                    ? ''
                                    : 'selected';
                                acc.push(React.createElement(sok_ui_1.Dropdown2MenuItem, { key: pm.identifier, onClick: function () {
                                        if (props.currentProject) {
                                            props.selectCustomMeta([pm], value === 'selected' ? true : false, props.currentProject.id);
                                        }
                                    } },
                                    React.createElement("span", null,
                                        React.createElement(sok_ui_1.Icon, { className: value ? 'fa-check-square' : 'fa-square', prefix: "far" }),
                                        "\u00A0",
                                        pm.name)));
                                return acc;
                            }, []))))));
    return null;
};
exports.default = ListColumnsToggle;
